import React, { useState } from 'react'

import { LoadingFeedback } from 'components'
import { Simplified } from 'views/Incidents/components/IncidentsForm/components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

const InvestigationStep = () => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { incident, setIncident, handleNext, isShow } = useIncidentManegement()

  const onSubmit = async (data) => {
    if (isShow) {
      handleNext()
      return
    }

    setLoading(true)

    try {
      const response = await service.dponet.incidents.investigationStep({
        incidentId: incident?.id,
        incident: data,
      })

      const incidentResponse = response?.data?.incident
      setIncident(incidentResponse)

      handleNext()
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro',
        variant: 'error',
      })
    }

    setLoading(false)
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <Simplified incident={incident} handleSubmit={onSubmit} />
    </>
  )
}

export default InvestigationStep
